export const forBusiness_creative_changer = [
	{
		icon: '💰',
		title: 'changerData_title1',
		subtitle: 'changerData_subtitle1',
	},
	{
		icon: '⏳',
		title: 'changerData_title2',
		subtitle: 'changerData_subtitle2',
	},
	{
		icon: '🥲',
		title: 'changerData_title3',
		subtitle: 'changerData_subtitle3',
	},
	{
		icon: '📈',
		title: 'changerData_title4',
		subtitle: 'changerData_subtitle4',
	},
];
